<mat-card>
  <div class="detail-view-container">
    <div class="edit-delete-close-buttons">
      @if (!type()) {
        <button mat-icon-button (click)="editEntity()" tabindex="-1">
          <mat-icon>edit</mat-icon>
        </button>
      }

      <button mat-icon-button (click)="deleteEntity()" tabindex="-1">
        <mat-icon>delete</mat-icon>
      </button>
      <button mat-icon-button mat-dialog-close tabindex="-1">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-card-header>
      <div class="header-container">
        <mat-icon class="icon">{{ icon() }}</mat-icon>
        <div>
          <mat-card-title>{{ title() || '' | truncate: 24 }}</mat-card-title>
          <mat-card-subtitle class="subtitle">{{ subtitle() || '' | truncate:24 }}</mat-card-subtitle>
        </div>
      </div>
    </mat-card-header>
    <mat-card-content>
      <ng-content></ng-content>
    </mat-card-content>
  </div>
</mat-card>
